import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import commonUtil from '../../../utils/commonUtil';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import pdfUtil from '../../../utils/PDFUtil';
import StatementPrintAndDownload from '../../BrowseAndNavigate/AccountSummary/components/StatementPrintAndDownload';
import Link from '../../../components/ZUILib/Link';
import Image from '../../../components/ZUILib/Image';
import { sendMail } from '../../BrowseAndNavigate/AccountSummary/actions';
import SelectionTab from '../../../components/ZUILib/SelectionTab';
import MultiSelectDropdown from '../../../components/MultiSelectDropdown';
import Pagination from '../../../components/Pagination';
import DownloadPDFWithoutPreview from '../../../components/DownloadPDFWithoutPreview';
import { constDownload, constPrint, constSendMail, UIBrands } from '../../../utils/clientConstant';
import NoGiftItemsMessage from './subComponents/NoGiftItemsMessage';
import DownloadPDFWithoutPreviewStatement from '../../../components/DownloadPDFWithoutPreview/statementWithHeader';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'accountstatus';

class GiftSummaryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSendStatus: null,
    };
    this.eventId = this.props.eventId;
    this.eventInfo = this.props.eventInfo;
    this.isViewAll = false;
    this.currentPage = 1;
  }

  componentDidMount() {

  }
  
  getStatementDetailsForDownload = (isBonusContainerVisible) => {
    this.printDownloadMail(constDownload,isBonusContainerVisible);
  }
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  }
  getStatementDetailsForSendMail = (isBonusContainerVisible) => {
    this.printDownloadMail(constSendMail,isBonusContainerVisible);
  }
  accountStatementSendMail = (fileName, data) => {
    const emailId = !commonUtil.isObjectEmpty(this.props.user) && this.props.user.result && this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status && res.body.status.status && res.body.status.status === 'success') {
         this.props.showMessagePopUp(true,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailsent.message',
        ));
      } else {
        this.props.showMessagePopUp(false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailfailed.message',
        ));
      }
    }).catch((e) => {
      pdfUtil.contentDownloadedCallback();
      this.props.showMessagePopUp(false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailfailed.message',
        ));
    });
  }

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }

  contentDownloadedCallback = () => {
    ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(document.querySelector('#downloadContainer')));
    commonUtil.hideApplicationLoader();

    this.props.showMessagePopUp(true,commonUtil.getLabel(
      this.props.lables.eventAccountStatement,
      'accountStatement.download.success.message',
    ));
  }

  printDownloadMail = (type,isBonusContainerVisible) => {
    if (type === constSendMail) {
      // const mailContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} isBonusContainerVisibleGL={isBonusContainerVisible} /></DownloadPDFWithoutPreview>);
      // pdfUtil.attachToDomForMail(mailContent, 'accountStatement', this.accountStatementSendMail);
      this.accountStatementSendMail();
    } else if (type === constDownload) {
      const downloadableContent = (<DownloadPDFWithoutPreviewStatement pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} isBonusContainerVisibleGL={isBonusContainerVisible} /></DownloadPDFWithoutPreviewStatement>);
      pdfUtil.attachToDom(downloadableContent, ('accountstatus_' + this.eventId), this.contentDownloadedCallback);
    } else if (type === constPrint) {
      const printContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate}><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  }

  onViewAllClick = () => {
    this.isViewAll = true;
    this.props.getFilterSorted(this.props.filteringParameters, this.props.sortingParameters, this.currentPage, true);
  }

  onPageChange = (value) => {
    this.currentPage = value;
    this.props.getFilterSorted(this.props.filteringParameters, this.props.sortingParameters, this.currentPage, false);
  }

  onSortChange = (type, value) => {
    /*eslint-disable*/
    const sortingParameters = this.props.sortingParameters;
    const compareVal = value === 'ascending' ? 'descending' : (value === 'increasing' ? 'decreasing' : (value === 'yes' ? 'no' : 'ascending'));
    // Patch for allow only one sort
    const patchSort = [];
    if (sortingParameters.length && sortingParameters[0].type === type) {
      if (sortingParameters[0].value === value) {
        patchSort.push({ type: type, value: compareVal });
      } else {
        patchSort.push({ type: type, value: value });
      }
    } else {
      patchSort.push({ type: type, value: compareVal });
    }

    this.props.getFilterSorted(this.props.filteringParameters, patchSort, this.currentPage, this.isViewAll);
    /*eslint-enable*/
  }
  redirectToPage = () => {
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: this.props.eventId }));
  }

  splitPrice = (value, withoutDot) => {
    const str = String(value).trim();
  
    const match = str.match(/^(\D?)([\d,]+)(?:\.(\d+))?$/);
    if (!match) {
      return {
        currency: '$',
        integerWithDot: withoutDot ? '0' : '0.',
        decimal: '00'
      };
    };
  
    const currency = match[1] || '';
    const rawIntegerPart = match[2].replace(/,/g, '');
    const decimalPart = match[3] || '00';
  
    const formattedInt = Number(rawIntegerPart).toLocaleString();
  
    return {
      currency,
      integerWithDot: withoutDot ? formattedInt : formattedInt + '.',
      decimal: decimalPart.padEnd(2, '0')
    };
  }

  render() {
    const { isPhysical,isElectronic,isPersonal,selectedTheme,isBonusContainerVisible,eventDaysleft } = this.props;


    const giftlistSummaryGiftText = isPhysical
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.physical.summary.gift.text',
            )
            : isElectronic
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.electronic.summary.gift.text',
            )
            : isPersonal
            ? commonUtil.getLabel(
              this.props.lables.eventAccountStatement,
              'accountStatement.personal.summary.gift.text',
            )
            : "";

    const paginationInfo = {
      "totalNoOfRecords": this.props.purchasedItemsDetailsData && this.props.purchasedItemsDetailsData.totalRecords ? this.props.purchasedItemsDetailsData.totalRecords : '1',
      "recordsPerPage": this.props.purchasedItemsDetailsData && this.props.purchasedItemsDetailsData.resultsPerPage ? this.props.purchasedItemsDetailsData.resultsPerPage : '10',
      "currentPage": this.currentPage ? this.currentPage.toString() : '1',
    };
        
    const DownloadIcon = {
      route: '',
    };
    const RegresarLink = {
      text: 'Regresar',
      children: 'Regresar',
      cssClass: 'lightLink size-Medium',
      onClickHandler: this.redirectToPage,
    };
    const viewAll = {
      text: 'Ver todo',
      href: 'javascript:void(0);',
      onClickHandler: this.onViewAllClick,
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.setState({ emailSendStatus: null }); },
    };

      const sortUpIcon = (<i className="iClass icon-flecha_filtros_arriba filter-arrow" aria-hidden="true" />);
      const sortDownIcon = (<i className="iClass icon-flecha_filtros_abajo filter-arrow" aria-hidden="true" />);

      const productImage = (data, index) => {
        const intransitImg = [
          {
            srcSet: data.imageURL,
          },
        ];

        const isGiftCertificate = data.categoryName === "Gift Certificate" || data.categoryName === "Certificado Electrónico";
  
        const intransitImage = {
          id: "product-image",
          src: data.imageURL,
          altImg: data?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
          width: 88,
          height: isGiftCertificate ? 55 : 106,
          className: "product-image",
        };
  
        return (
          <Image imageAttr={intransitImage} _imgsrc={intransitImg} />
        )
      }

      const themeColor500 = selectedTheme?.color_500;
      const themeColor50 = selectedTheme?.color_50;
      const themeColor700 = selectedTheme?.color_700;

      const noOfDaysLeftLabel = commonUtil.getLabel(
        this.props.lables.eventAccountStatement,
        'accountStatement.gift.table.event.noOfDays.left.text',
      )

      const productPrice = (price) => {
        let formattedPrice = price ? commonUtil.getCurrency(price) : '$0';
        formattedPrice = this.splitPrice(formattedPrice,true);

        return (
          <div className='giftlist-giftsku-price-box col-lg-3 col-md-3 pr-0'>
              <span className='giftlist-giftsku-price'>{formattedPrice.currency} {formattedPrice.integerWithDot}</span>
              <span className='giftlist-giftsku-price-decimal'>{formattedPrice.decimal}</span>
          </div>
        )
      }

      const noOfDaysLeftLabelParts = noOfDaysLeftLabel.split('{0}');
      const purchasedItemSummaryInfoData = this.props.purchasedItemSummaryInfoData;

    return (
        <div className='giftlist-table-container  col-lg-9 col-xl-9 col-sm-9'>
            <div className='giftlistsummary-table-header-container'>
                <div style={{'--color-50': themeColor50}} className='giftlist-summary-gift-box'>
                   {isPhysical ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M12.5 6.19L17.5 10.69V18.5H15.5V12.5H9.5V18.5H7.5V10.69L12.5 6.19ZM12.5 3.5L2.5 12.5H5.5V20.5H11.5V14.5H13.5V20.5H19.5V12.5H22.5L12.5 3.5Z" fill={themeColor500}/>
                    </svg> : isElectronic ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM12.81 11.14C11.04 10.69 10.47 10.2 10.47 9.47C10.47 8.63 11.26 8.04 12.57 8.04C13.95 8.04 14.47 8.7 14.51 9.68H16.22C16.17 8.34 15.35 7.11 13.73 6.71V5H11.4V6.69C9.89 7.01 8.68 7.99 8.68 9.5C8.68 11.29 10.17 12.19 12.34 12.71C14.29 13.17 14.68 13.86 14.68 14.58C14.68 15.11 14.29 15.97 12.58 15.97C10.98 15.97 10.35 15.25 10.26 14.33H8.54C8.64 16.03 9.9 16.99 11.4 17.3V19H13.74V17.33C15.26 17.04 16.46 16.17 16.47 14.56C16.46 12.36 14.57 11.6 12.81 11.14Z" fill={themeColor500}/>
                    </svg> : isPersonal ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M22.5 10.8703L19.76 9.28033C20 9.07033 20.23 8.80033 20.4 8.50033C21.23 7.07033 20.74 5.23033 19.3 4.40033C18.44 3.90033 17.43 3.90033 16.58 4.26033L16.59 4.25033L15.71 4.64033L15.6 3.68033L15.59 3.69033C15.5 2.78033 14.97 1.90033 14.11 1.40033C12.67 0.57533 10.84 1.07033 10 2.50033C9.83 2.80033 9.72 3.13033 9.66 3.45033L6.91 1.87033C5.95 1.32033 4.73 1.64033 4.18 2.60033L2.68 5.20033C2.4 5.68033 2.57 6.29033 3.05 6.56033L4.78 7.56033L9 10.0003H2.5V20.0003C2.5 21.1103 3.4 22.0003 4.5 22.0003H20.5C21.61 22.0003 22.5 21.1103 22.5 20.0003V14.8703L23.23 13.6003C23.78 12.6403 23.46 11.4203 22.5 10.8703ZM16.94 6.50033C17.21 6.00033 17.83 5.86033 18.3 6.13033C18.78 6.41033 18.95 7.00033 18.67 7.50033C18.39 8.00033 17.78 8.14033 17.3 7.87033C16.83 7.59033 16.66 7.00033 16.94 6.50033ZM14.57 8.60033L21.5 12.6003L20.5 14.3303L13.57 10.3303L14.57 8.60033ZM11.5 20.0003H4.5V12.0003H11.5V20.0003ZM11.84 9.33033L4.91 5.33033L5.91 3.60033L12.84 7.60033L11.84 9.33033ZM12.11 4.87033C11.63 4.59033 11.47 4.00033 11.74 3.50033C12 3.00033 12.63 2.86033 13.11 3.13033C13.59 3.41033 13.75 4.00033 13.47 4.50033C13.2 5.00033 12.59 5.14033 12.11 4.87033ZM13.5 20.0003V12.6003L20.5 16.6403V20.0003H13.5Z" fill={themeColor500}/>
                    </svg> : '' }
                    <span style={{'--color-700': themeColor700}} className='giftlist-summary-gift-text'>{giftlistSummaryGiftText}</span>
                </div>

                {purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount > 0 && 
                  <div className='giftlist-gifttable-close-box'>
                      <span className='giftlist-gifttable-close-text'>
                        {commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.gift.table.download.statement.text',
                        )}
                      </span>
                    
                      <div className='giftlist-gifttable-closedays-icons'>
                        <svg className='cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={() => this.getStatementDetailsForDownload(isBonusContainerVisible)}>
                            <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="#333333"/>
                        </svg>
                        <svg className='cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={() => this.getStatementDetailsForSendMail(isBonusContainerVisible)}>
                            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#333333"/>
                        </svg>
                      </div>                                       
                  </div>
                }
                {(!_.isEmpty(this.props.purchasedItemsDetailsData) &&
                        !_.isEmpty(this.props.purchasedItemsDetailsData.itemsInfo) || (this.props.purchasedItemsDetailsData?.itemsInfo?.length > 0)) && <>
                <div className='giftlist-gifttable-count'>
                    <span className='giftlist-gifttable-count-text'>{this.props?.purchasedItemsDetailsData?.itemsCount || '0'} <span className='giftlist-gifttable-count-text-label'>{commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.gift.table.product.text',
                    )}</span></span>
                </div>
                <div className='giftlist-gifttable-header-box'>
                    <div className='giftlist-gifttable-header col-lg-12 col-md-12'>
                        <div class="col-lg-1 col-md-1"></div>
                        <span className='giftlist-gifttable-header-text col-lg-4 col-md-4'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.articulo.label')}</span>
                        <div className='giftlist-gifttable-header-price col-lg-3 col-md-3'>
                            <svg className='cursor-pointer' onClick={() => this.onSortChange('amount', 'ascending')} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z" fill="#333333"/>
                            </svg>
                            <span className='giftlist-gifttable-header-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.price.label')}</span>
                        </div>
                        <span className='giftlist-gifttable-header-text giftlist-gifttable-header-text-padding col-lg-4 col-md-4'>{commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.gift.table.item.details.text',
                        )}</span>
                    </div>
                </div></>}
                {(_.isEmpty(this.props.purchasedItemsDetailsData) &&
                        _.isEmpty(this.props.purchasedItemsDetailsData?.itemsInfo) || (this.props.purchasedItemsDetailsData?.itemsInfo?.length == 0)) && 
                  <NoGiftItemsMessage lables={this.props.lables} quantity={purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount}/>
                }
            </div>
            {!_.isEmpty(this.props.purchasedItemsDetailsData) &&
                        !_.isEmpty(this.props.purchasedItemsDetailsData.itemsInfo) && this.props.purchasedItemsDetailsData.itemsInfo.map((product,index) => (
                <>
                    <div className='giftlist-gifttable-item-box'>
                        <div className='giftlist-gifttable-item col-lg-12 col-md-12 col-sm-12'>
                            <div className='giftlist-gifttable-item-image'>
                              {productImage(product)}
                            </div>
                            <div className='giftlist-giftskudetails-box col-lg-4 col-md-4 pl-0'>
                                <span className='giftlist-giftskudetails-name'>{product.displayName}</span>
                                <div className='giftlist-giftskudetails-skuId-cantidad'>
                                    <div className='giftlist-giftskudetails-skuId-box'>
                                        <span className='giftlist-giftskudetails-skuId-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}: </span>
                                        <span className='giftlist-giftskudetails-skuId'>{product.skuId}</span>
                                    </div>
                                    <div className='giftlist-giftskudetails-skuId-box'>
                                        <span className='giftlist-giftskudetails-skuId-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.qty.label')}: </span>
                                        <span className='giftlist-giftskudetails-skuId'>{product.quantity}</span>
                                    </div>
                                </div>
                                {!isPersonal && 
                                <div className='giftlist-giftskudetails-skuId-box'>
                                    <span className='giftlist-giftskudetails-guest'>{commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.delivery.address.invited.label")}: </span>
                                    <span className='giftlist-giftskudetails-guest-text'>{product.guestInfo.name ? product.guestInfo.name : commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.guest.name") || ""}</span>
                                </div>}
                                {isBonusContainerVisible &&
                                <div className='giftlist-giftskudetails-bonus'>
                                    <span className='giftlist-giftskudetails-bonus-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.bonus.label")}</span>
                                    {(product.bonusInfo === "true") ? 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M4.39961 7.95039L2.29961 5.85039L1.59961 6.55039L4.39961 9.35039L10.3996 3.35039L9.69961 2.65039L4.39961 7.95039Z" fill="#0ABD3E"/>
                                    </svg> : 
                                    <div className="bono-text">
                                      <span>X</span>
                                    </div>
                                    }
                                </div>}
                            </div>
                            {/* <div className='giftlist-giftsku-pricedetails-box'> */}
                                {productPrice(product.price)}
                                <div className='giftlist-giftsku-store-box col-lg-4 col-md-4'>
                                    <div className='giftlist-giftsku-store'>
                                        <span className='giftlist-giftsku-store-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.regalosrecibidos.warehouse.label")}: </span>
                                        <span className='giftlist-giftsku-store-text2'>{product?.guestInfo?.popupStore ? product.guestInfo.popupStore : product?.purchaseInfo?.warehouseInfo || '' }</span>
                                    </div>
                                    <div className='giftlist-giftsku-store'>
                                        <span className='giftlist-giftsku-store-text'>{commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.date.label")}: </span>
                                        <span className='giftlist-giftsku-store-text2'>{product?.guestInfo?.dateofPurchase ? product.guestInfo.dateofPurchase : product?.purchaseInfo?.dateofPurchase || ''}</span>
                                    </div>
                                </div>
                            {/* </div> */}
                        </div>
                    </div>                    
                </>
            )) 
            
            // : <div className='giftlist-gifttable-no-items'>Aún no tienes artículos asociados a tu mesa de regalos.</div>
            }
            {purchasedItemSummaryInfoData?.itemSummary?.totalPurchasedItemsCount > 0 && 
              <div className='giftlist-gifttable-returnbtn-box col-lg-12 col-md-12 col-sm-12'>
                  <button 
                    style={{'--color-500': themeColor500}}
                    className='giftlist-gifttable-returnbtn col-lg-3 col-md-3 col-sm-3'
                    onClick={this.redirectToPage}
                  >
                      {commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.gift.table.remove.movement.text',
                      )}
                  </button>

                  {paginationInfo && +paginationInfo.totalNoOfRecords > +paginationInfo.recordsPerPage &&
                    <div className="paginator paginatorGL col-lg-9 col-md-9 col-sm-9">
                      {!this.isViewAll ? <div>
                        <Pagination paginationInfo={paginationInfo} onPageChange={this.onPageChange} giftSummary={true}/></div> : ''}
                    </div>
                  }
              </div>
            }
        </div>
   );
  }
}

export default GiftSummaryTable;